define('commons/simple-multi-slider',['jquery', 'jquery.ui'], function ($) {

    var SimpleMultiSlider = function(slideId, values, colors, min, max, options) {
        this.slideId = slideId;
        this.slide1 = $(slideId);
        this.min = min;
        this.max = max;
        this.values = values;
        this.colors = colors;
        
        this.settings = {
                rawValue : function(sliderValue) {return sliderValue;},
                valuesNames : null
            };
        $.extend(this.settings, options);
        
        this.create();
    };
    
    /**
     * Could be overridden but call this super method first.
     */
    SimpleMultiSlider.prototype.doUpdate = function(event, ui) {
        if (ui && ui.values) {
            for (var i = 0; i < ui.values.length; i++) {
                var curValue = ui.values[i];
                if(i !== this.values.length -1 && curValue > ui.values[i + 1]) {
                    event.preventDefault();
                    return false;
                } else if (i === 0 && curValue < ui.values[i - 1]) {
                    event.preventDefault();
                    return false;
                }
            }
        }
        $(this.slideId + ' .slide-back').remove();
        this.slide1.css('background', '#' + this.colors[this.colors.length-1]);
        var here = this;
        
        $($(this.slideId + ' span').get().reverse()).each(function(i) {
            bg = '#' + here.colors[here.colors.length-1 - i -1];
            here.slide1.append($('<div></div>').addClass('slide-back').width($(this).position().left - 5).css('background-color', bg));
            var curValue;
            if (ui && ui.values) {
                curValue = ui.values[i];
            } else {
                curValue = here.values[i];
            }
            var target = $("span.ui-slider-handle")[i];
            var tooltip = '<div class="tooltip"><div class="tooltip-inner">' + here.settings.rawValue(curValue) + '</div><div class="tooltip-arrow"></div></div>';
            $(target).html(tooltip);
            here.values[i] = curValue;
        });
    };
    
    
    SimpleMultiSlider.prototype.create = function() {
        this.slide1.slider({
            slide: $.proxy(this.doUpdate, this),
            change: $.proxy(this.doUpdate, this),
            min: this.min,
            max: this.max,
            values: this.values,
            create: $.proxy(this.doUpdate, this)
        });
        
        window.onresize = $.proxy(function(event) {
            this.doUpdate();
        },this);
    };
    
    /**
     * Returns an array with values/names couples: [{value:10, name:"goodQuality"} , {value:20, name:"excellentQuality"}, ...]
     */
    SimpleMultiSlider.prototype.getValuesWithNames = function() {
        var res = [];
        for(var i= 0, length = this.values.length; i< length; i++){
            res.push({value: this.values[i], name: this.settings.valuesNames[i]});
        }
        return res;
    };
    
    SimpleMultiSlider.prototype.destroy = function() {
        $(this.slideId + ' .slide-back').remove();
        this.slide1.slider( "destroy" );
    };

    return SimpleMultiSlider;
});


